import { Component } from '@angular/core'
import { trigger, state, style, transition, animate } from '@angular/animations'
import { DialogRef } from '@angular/cdk/dialog'
import { SharedModule } from '../../shared/shared.module'

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    imports: [SharedModule],
    animations: [
        trigger('buttonHover', [
            state('normal', style({
                'background-color': '#0176ac'
            })),
            state('highlighted', style({
                'background-color': '#757575'
            })),
            transition('normal <=> highlighted', animate(100)),
        ])
    ]
})
export class ForgotPasswordComponent {

  submitButtonState = 'normal'
  cancelButtonState = 'normal'
  constructor(public dialogRef: DialogRef<ForgotPasswordComponent>) { }

  changeSubmitButtonState() {
    if (this.submitButtonState === 'normal') {
      this.submitButtonState = 'highlighted'
    } else {
      this.submitButtonState = 'normal'
    }
  }

  changeCancelButtonState() {
    if (this.cancelButtonState === 'normal') {
      this.cancelButtonState = 'highlighted'
    } else {
      this.cancelButtonState = 'normal'
    }
  }

}
